/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  TransactionTypeCheckRequest,
  TransactionTypeCheckResponse,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * **Deprecated:** Use `POST /transaction-type/check` instead. This endpoint is kept for backward compatibility.
 * @deprecated
 * @summary Check VIES status (deprecated)
 */
export type checkViesResponse200 = {
  data: TransactionTypeCheckResponse
  status: 200
}

export type checkViesResponse400 = {
  data: Error
  status: 400
}

export type checkViesResponse401 = {
  data: Error
  status: 401
}

export type checkViesResponse403 = {
  data: Error
  status: 403
}

export type checkViesResponse404 = {
  data: Error
  status: 404
}

export type checkViesResponse422 = {
  data: ValidationError
  status: 422
}

export type checkViesResponse500 = {
  data: Error
  status: 500
}

export type checkViesResponseSuccess = (checkViesResponse200) & {
  headers: Headers;
};
export type checkViesResponseError = (checkViesResponse400 | checkViesResponse401 | checkViesResponse403 | checkViesResponse404 | checkViesResponse422 | checkViesResponse500) & {
  headers: Headers;
};

export type checkViesResponse = (checkViesResponseSuccess | checkViesResponseError)

export const getCheckViesUrl = () => {


  

  return `/vies/check`
}

export const checkVies = async (transactionTypeCheckRequest: TransactionTypeCheckRequest, options?: RequestInit): Promise<checkViesResponse> => {
  
  return customFetch<checkViesResponse>(getCheckViesUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      transactionTypeCheckRequest,)
  }
);}
  

